import React, {FC} from 'react';

import {Trans} from '../../../../../../libs/shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {InlineLinkButton} from '../../../../../../libs/shared/ui/src/components/buttons/inlineLinkButton';
import {useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {SmartDateTimeFormatterContainer} from '../../../../../../srcCommon/formatters/dateTime/smartDateTimeFormatterContainer';
import {ReminderModel} from '../../../../../models/api/reminderModel';
import {ActivityWithIcon} from '../activityWithIcon/activityWithIcon';
import {BasicViewerBase, StyledBasicGroupDiv} from './basicViewerBase';

/*
 * Props.
 */

interface BasicViewerResnoozeProps {
  canceledReminder?: ReminderModel;
  onResnoozeClick: Handler;
}

/*
 * Component.
 */

export const BasicViewerResnooze: FC<BasicViewerResnoozeProps> = (props) => {
  const theme = useUserTheme();
  const {canceledReminder, onResnoozeClick} = props;

  if (!canceledReminder) {
    return null;
  }

  const renderByLine = () => {
    if (canceledReminder.canceledById) {
      return <Trans id="message-viewer-resnooze-byreply">by this reply</Trans>;
    }

    return <Trans id="message-viewer-resnooze-byactivity">by a recent activity</Trans>;
  };

  return (
    <>
      <div />
      <StyledBasicGroupDiv>
        <BasicViewerBase isPreviousActivityBasic={false}>
          <ActivityWithIcon iconName="snoozeActivityFilled" iconColor={theme.palette.orange.shade40}>
            <strong>
              <Trans id="message-viewer-resnooze-canceled">Snooze canceled</Trans>
            </strong>{' '}
            {renderByLine()} &bull;{' '}
            <InlineLinkButton onClick={onResnoozeClick}>
              <Trans id="message-viewer-resnooze-action">
                Snooze again until <SmartDateTimeFormatterContainer value={canceledReminder.remindAt} />
              </Trans>
            </InlineLinkButton>
          </ActivityWithIcon>
        </BasicViewerBase>
      </StyledBasicGroupDiv>
    </>
  );
};
